import { gt } from '~/locale'
import { NextPageWithLayout } from '~/pages/_app'

import BlogBanner from '../../BlogBanner/BlogBannerView'
import { BlogPostType } from '../../BlogPostCard/BlogPostCardTypes'
import BlogSection from '../../BlogSection'
import HomePageHero from '../../HomePageHero'

import { ArticlesSection, BlogContainer } from './BlogMainPageShards'

interface Props {
  heroMainArticle: BlogPostType
  heroLatestArticles: BlogPostType[]
  initialArticles: BlogPostType[]
  featuredArticlesIds: Array<number>
  headline: string
}

const BlogPageMainView: NextPageWithLayout<Props> = ({ heroMainArticle, heroLatestArticles, initialArticles, featuredArticlesIds }) => {
  return (
    <>
      <BlogBanner />
      <BlogContainer>
        <HomePageHero main={heroMainArticle} latest={heroLatestArticles} />
        <ArticlesSection>
          <BlogSection
            initialArticles={initialArticles}
            featuredArticlesIds={featuredArticlesIds}
            title={gt.tp('Blog', 'Recent Articles')}
            divider='bottom'
          />
        </ArticlesSection>
      </BlogContainer>
    </>
  )
}

export default BlogPageMainView
